import { FormView } from '../account/form-view';
import { ApiUtil } from '../utils/api-util';
import constants from '../utils/constants';
import "firebase/auth";

export default FormView.extend({

    executeOperation: function() {
        let emailAddress = this.el.querySelector("#emailAddress");

        return new Promise((resolve, reject) => {

            let apiPath, data = {};
            let optin = this.el.querySelector('#newsletterOptIn:checked');
            let successElem = this.el.querySelector('.js-newsletter-success');

            if (optin) {

                apiPath = constants.NEWSLETTER_SIGNUP_URL;
                let usernameElem = document.querySelector('.js-username');
                let username = usernameElem ? usernameElem.innerHTML : "";
                data = {
                    version: 2,
                    name: username.trim(),
                    email: emailAddress.value,
                    isHomeAndLiving: false
                };
        
            } else {

                apiPath = constants.NEWSLETTER_UNSUBSCRIBE_URL;
                data = {
                    version: 1,
                    email: emailAddress.value,
                }
            }


            ApiUtil.request({
                method: 'POST',
                data: data,
                path: apiPath,
                success: function() { 
                    if (optin) { 
                        successElem.classList.remove('newsletter-success--optout');
                        successElem.classList.add('newsletter-success--optin');
                    } else { 
                        successElem.classList.remove('newsletter-success--optin');
                        successElem.classList.add('newsletter-success--optout'); 
                    }
                    resolve();
                },
                error: function() { reject(getI18N(jlocale.error)); }
            });
        });
    }
})